import {createMultiPathSVG} from './TEMPLATE'

// phosphor: chat-circle
export const BubbleInfo_Stroke2_Corner2_Rounded = createMultiPathSVG({
  paths: [
    'M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z',
  ],
  viewBox: '0 0 256 256',
})
